/**
 * Plot Service Field Mapping
 * Maps plot service field names to their display labels and units
 * These labels should match the frontend_label or name in groundworks_rates_mapping.json
 */

/**
 * Mapping of plot service field names to their display labels
 */
export const PLOT_SERVICE_FIELD_LABELS: { [fieldName: string]: string } = {
  // Service Details
  'plots': 'Excavate service trenches from back of footpath to plots, including supply and lay duct or 25mm Mdpe pipes for water, gas, electric and BT (free issue) (Nr)',
  'apartments': 'Apartments (Nr)',
  'eo25mmBarrierPipe': 'EO for barrier pipes - 25mmØ (m)',
  'eo32mmBarrierPipe': 'EO for barrier pipes - 32mmØ (m)',
  'virginMedia': 'EO for Virgin Media duct installation (Nr)',
  'garageDuct': 'Between house and garage (Nr)',
  'privateStLightDuct': 'Private street lighting duct (m)',
  'pccEdgingsGasBoxes': 'PCC Edgings to gas boxes (Nr)',

  // Car Charging
  'ductingToChargingPoint': 'Ducting for car charging points (m)',
  'concBaseChargingPoints': 'Concrete base for charging point (Nr)',
  'installBollardBase': 'Install only bollard for charging point (Nr)',
  'airSourceHeatPump': 'Base for Air Source Heat Pump (Nr)',

  // Service Connection
  'serviceConnectionPlots': 'Plots (Nr)',
  'serviceConnectionApartments': 'Apartments (Nr)',
  'vacEx': 'Vac-ex (Nr)',
};

/**
 * Mapping of plot service field names to their units
 */
export const PLOT_SERVICE_FIELD_UNITS: { [fieldName: string]: string } = {
  // Service Details
  'plots': 'Nr',
  'apartments': 'Nr',
  'eo25mmBarrierPipe': 'm',
  'eo32mmBarrierPipe': 'm',
  'virginMedia': 'Nr',
  'garageDuct': 'Nr',
  'privateStLightDuct': 'm',
  'pccEdgingsGasBoxes': 'Nr',

  // Car Charging
  'ductingToChargingPoint': 'm',
  'concBaseChargingPoints': 'Nr',
  'installBollardBase': 'Nr',
  'airSourceHeatPump': 'Nr',

  // Service Connection
  'serviceConnectionPlots': 'Nr',
  'serviceConnectionApartments': 'Nr',
  'vacEx': 'Nr',
};

/**
 * Get the display label for a plot service field
 */
export function getPlotServiceFieldLabel(fieldName: string): string | undefined {
  return PLOT_SERVICE_FIELD_LABELS[fieldName];
}

/**
 * Get the unit for a plot service field
 */
export function getPlotServiceFieldUnit(fieldName: string): string | undefined {
  return PLOT_SERVICE_FIELD_UNITS[fieldName];
}

/**
 * Reverse mapping: label to field name
 */
export const PLOT_SERVICE_REVERSE_MAPPING: { [label: string]: string } = {};
Object.entries(PLOT_SERVICE_FIELD_LABELS).forEach(([fieldName, label]) => {
  PLOT_SERVICE_REVERSE_MAPPING[label] = fieldName;
});
